import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { CmoveQuotaDoc, CmoveQuotaService } from '../../services/cmove-quota.service';

@Component({
  selector: 'app-cmove-quota-bar',
  templateUrl: './cmove-quota-bar.component.html',
  styleUrls: ['./cmove-quota-bar.component.scss'],
  standalone: false,
})
export class CmoveQuotaBarComponent implements OnChanges, OnDestroy {
  @Input() ownerID: string | null = null;

  quota: CmoveQuotaDoc | null = null;
  private sub: Subscription | null = null;

  constructor(private cmoveQuota: CmoveQuotaService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ownerID']) {
      this.sub?.unsubscribe();
      this.quota = null;
      if (this.ownerID) {
        this.sub = this.cmoveQuota.watchQuota(this.ownerID).subscribe({
          next: q => (this.quota = q),
          error: err => console.warn('[CmoveQuotaBar] watchQuota error:', err),
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get effectiveQuota(): number {
    if (!this.quota) return 0;
    return this.quota.quotaOverride ?? this.quota.quota ?? 5;
  }

  get percentage(): number {
    if (!this.quota || this.effectiveQuota === 0) return 0;
    return Math.min(100, Math.round((this.quota.usageCount / this.effectiveQuota) * 100));
  }

  get barColor(): 'primary' | 'accent' | 'warn' {
    if (this.percentage >= 90) return 'warn';
    if (this.percentage >= 70) return 'accent';
    return 'primary';
  }
}
